import { twMerge } from "tailwind-merge"

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string
  type?: "checkbox" | "radio"
  className?: string
  label?: React.ReactNode
  classNameWrapper?: string
}

const Checkbox: React.FC<CheckboxProps> = (_props_) => {
  const { className, type = "checkbox", label, id, classNameWrapper = "", ...props } = _props_
  const baseClasses = "rounded text-legacy-blue ring-legacy-blue focus:ring-legacy-blue"
  return (
    <div className={twMerge("flex items-center space-x-2 pointer-events-auto", classNameWrapper)}>
      <input type={type} id={id} className={twMerge(baseClasses, className)} {...props} />
      {label && (
        <label htmlFor={id} className="cursor-pointer text-sm">
          {label}
        </label>
      )}
    </div>
  )
}

export default Checkbox
